/** Stub for CDN bundle */
const noop = () => {};
export const Cookie = { get: noop, set: noop };
